import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  TableCell,
  TableRow,
  TextField,
} from "@material-ui/core";

import {
  deleteMaterial,
  setearValorEnMaterial,
} from "../../../actions/autorizaciones/Autorizaciones";

import LetterX from "../UI/LetterX";

import {
  AUTORIZACIONES_BANDEJAS,
  AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS,
  AUTORIZACIONES_MATERIALES_ESTADOS,
  AUTORIZACIONES_PRESUPUESTOS_ESTADOS,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  TIPOS_AUTORIZACIONES,
} from "../../../utils/constants";
import { startAlerta } from "../../../actions/ui/alertas";

export const AutorizacionesMaterial = (props) => {
  const dispatch = useDispatch();

  const { estadoSolicitudes } = useSelector((state) => state.autorizaciones);

  const [cantidad, setCantidad] = useState(props.material?.cantidad ? props.material?.cantidad : 1);
  const [valorUnitario, setValorUnitario] = useState(props.material?.valorUnitario ? props.material?.valorUnitario : null);

  const { bandejasAutorizacion = [] } = useSelector(
    (state) => state.auth
  );

  /* const deleteMaterialHandler = (id) => {
    const materialesAux = props.materiales?.filter(
      (material) => material.idMaterial !== id
    );
    // props.setMateriales(materialesAux);
  }; */

  const esAuditorIntDom = bandejasAutorizacion.filter((bandeja) => bandeja.idBandeja === AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA)
  const disabledPropAuditor = (
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA ||
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
    esAuditorIntDom.length === 0
  ) ? true : false;

  

  const disabledValorUni = (props.presupuestoSeleccionado?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS
    && props.presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
  ) ? false : parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES || props.disabled
  || (props.material?.idEstadoMaterial !== 1 && props.material?.idEstadoMaterial !== undefined);

  return (
    <>
      <TableRow>
        {props.enabledMaterialActions && props.material.idEstadoMaterial === 1 &&
          /* !props.noMostrarEstado  && !props.desdeAuditar && */
          (
            <TableCell>
              <LetterX
                deleteFunction={() => {
                  (props.material?.idEstadoMaterial !== AUTORIZACIONES_MATERIALES_ESTADOS.GESTION &&
                    props.material?.idEstadoMaterial !== AUTORIZACIONES_MATERIALES_ESTADOS.PENDIENTE
                  )
                    ?
                    dispatch(startAlerta("No se puede eliminar un material con estado AUTORIZAD/RECHAZADO", "warning"))
                    :
                    dispatch(
                      deleteMaterial(
                        props.practica?.idCodNom,
                        props.material?.idMaterial
                      )
                    );
                  // deleteMaterialHandler(props.material?.idMaterial);
                }}
                styles={{
                  cursor: "pointer",
                  position: "relative",
                  top: "0.25rem",
                  marginRight: "0.5rem",
                }}
              />
            </TableCell>
          )
        }
        {props.enabledMaterialActions && props.material.idEstadoMaterial !== 1 &&
          (
            <TableCell>
              {""}
            </TableCell>
          )
        }
        <TableCell>{props.material?.material?.descripcion}</TableCell>
        <TableCell>
          <TextField
            variant="outlined"
            type="number"
            label="Cantidad"
            value={cantidad}
            disabled={parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES || props.disabled
              || (props.material?.idEstadoMaterial !== 1 && props.material?.idEstadoMaterial !== undefined)
            }
            onChange={(e) => {
              setCantidad(e.target.value);
              dispatch(
                setearValorEnMaterial(
                  props.practica?.idCodNom,
                  props.material?.idMaterial,
                  "cantidad",
                  Number(e.target.value)
                )
              );
            }}
            error={cantidad <= 0}
            helperText={cantidad <= 0 && "Debe ser mayor a 0."}
          />
        </TableCell>
        {(props.solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS || props.presupuestoSeleccionado?.idPresupuesto !== null) &&
          props.desdeAuditar && (props.presupuestoSeleccionado?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS ||
            props.presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS ||
            props.presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
          ) &&
          <TableCell>
            <TextField
              variant="outlined"
              type="number"
              label="Valor Uni."
              value={valorUnitario}
              disabled={disabledValorUni}
              onChange={(e) => {
                setValorUnitario(e.target.value);
                dispatch(
                  setearValorEnMaterial(
                    props.practica?.idCodNom,
                    props.material?.idMaterial,
                    "valorUnitario",
                    Number(e.target.value)
                  )
                );
              }}
            //error={valorUnitario <= 0}
            //helperText={valorUnitario <= 0 && "Debe ser mayor a 0."}
            />
          </TableCell>}
        <TableCell>
          <FormGroup >
            <FormControlLabel
              style={{ alignSelf: 'end' }}
              control={<Checkbox checked={props.material?.recuperoSur} />}
              onChange={(e) => {
                dispatch(
                  setearValorEnMaterial(
                    props.practica?.idCodNom,
                    props.material?.idMaterial,
                    "recuperoSur",
                    e.target.checked
                  )
                );
              }}
              disabled={props.disabledRecupSur/* || (props.material?.idEstadoMaterial !== 1 && props.material?.idEstadoMaterial !== undefined)*/}
            />
          </FormGroup>
        </TableCell>
        {props.desdeAuditar && !props.noMostrarEstado && (
          <React.Fragment>
            <TableCell style={{ textAlign: "center" }}>
              <RadioGroup
                value={props.material?.idEstadoMaterial?.toString()}
                onChange={(e) => {
                  dispatch(
                    setearValorEnMaterial(
                      props.practica?.idCodNom,
                      props.material?.idMaterial,
                      "idEstadoMaterial",
                      parseInt(e.target.value)
                    )
                  );

                  if (props.evaluarPracticasMateriales && parseInt(e.target.value) === AUTORIZACIONES_MATERIALES_ESTADOS.RECHAZADO)
                    props.evaluarPracticasMateriales();
                }}
              >
                <FormControlLabel
                  label={"Autorizada"}
                  disabled={disabledPropAuditor}
                  value={AUTORIZACIONES_MATERIALES_ESTADOS.AUTORIZADO.toString()}
                  control={<Radio />}
                />
                <FormControlLabel
                  label={"Gestión"}
                  disabled={disabledPropAuditor}
                  value={AUTORIZACIONES_MATERIALES_ESTADOS.GESTION.toString()}
                  control={<Radio />}
                />
                <FormControlLabel
                  label={"Rechazada"}
                  disabled={disabledPropAuditor}
                  value={AUTORIZACIONES_MATERIALES_ESTADOS.RECHAZADO.toString()}
                  control={<Radio />}
                />
              </RadioGroup>
            </TableCell>
          </React.Fragment>
        )}
        {props.desdeAuditar && (
          <React.Fragment>
            {props.solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION
              && <TableCell style={{ textAlign: "center" }}>
                <RadioGroup
                  value={props.material?.idEstadoCompraMaterial?.toString()}
                  onChange={(e) => {
                    dispatch(
                      setearValorEnMaterial(
                        props.practica?.idCodNom,
                        props.material?.idMaterial,
                        "idEstadoCompraMaterial",
                        parseInt(e.target.value)
                      )
                    );
                    if (props.evaluarPracticasMateriales && parseInt(e.target.value) === AUTORIZACIONES_MATERIALES_ESTADOS.RECHAZADO)
                      props.evaluarPracticasMateriales();
                  }}
                >
                  <FormControlLabel
                    label={"Presupuesto"}
                    disabled={disabledPropAuditor}
                    value={AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS.PRESUPUESTO.toString()}
                    control={<Radio />}
                  />
                  <FormControlLabel
                    label={"Compra Directa"}
                    disabled={disabledPropAuditor}
                    value={AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS.COMPRA_DIRECTA.toString()}
                    control={<Radio />}
                  />
                  <FormControlLabel
                    label={"Reposicion"}
                    disabled={disabledPropAuditor}
                    value={AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS.REPOSICION.toString()}
                    control={<Radio />}
                  />
                </RadioGroup>
              </TableCell>}
            {parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
              && esAuditorIntDom
              && (
                <TableCell>
                  <FormGroup style={{
                    marginTop: props.solicitudSeleccionada?.idPresupuesto !== null &&
                      props.solicitudSeleccionada?.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS ? "18px" : "0px"
                  }}>
                    <FormControlLabel
                      control={<Checkbox checked={props.material?.disponible} />}
                      label="Disponible"
                      disabled={props.material?.idEstadoMaterial === AUTORIZACIONES_MATERIALES_ESTADOS.RECHAZADO}
                      onChange={(e) => {
                        dispatch(
                          setearValorEnMaterial(
                            props.practica?.idCodNom,
                            props.material?.idMaterial,
                            "disponible",
                            e.target.checked
                          )
                        );
                      }}
                    />
                  </FormGroup>
                  {props.solicitudSeleccionada?.idPresupuesto !== null &&
                    props.solicitudSeleccionada?.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS &&
                    <Grid item xs={12} style={{ color: 'black', marginTop: "-25px" }}>
                      <h5>Valor Presu.: $ {props.material?.valorUnitarioPresupuesto?.toFixed(2) ?? 0}</h5>
                    </Grid>}
                </TableCell>
              )}
          </React.Fragment>
        )}
      </TableRow>
    </>
  );
};
